
// components/QuickApplyModal.jsx
import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import ReviewApplicationModal from "./ReviewApplicationModal";

const QuickApplyModal = ({ job, onClose }) => {
  const [showReview, setShowReview] = useState(false);
  if (!job) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div className="bg-white w-full max-w-md rounded shadow-lg p-6 relative">
          {/* Header */}
          <div className="mb-4">
            <div className="text-xs text-gray-600 font-medium">Applying to</div>
            <div className="font-semibold text-sm ">
              {job.title}
            </div>
            <div className="text-xs text-gray-500">{job.company} in {job.location}</div>
            <button
              onClick={onClose}
              className="absolute right-4 top-4 text-gray-400 hover:text-black"
            >
              <IoClose size={22} />
            </button>
          </div>

          {/* Form */}
          <form
            className="space-y-4"
            onSubmit={(e) => {
              e.preventDefault();
              setShowReview(true);
            }}
          >
            <div>
              <label className="text-sm font-semibold">First name</label>
              <input
                type="text"
                defaultValue="kelly"
                className="w-full border rounded px-3 py-2 mt-1 text-sm focus:outline-none focus:ring"
              />
            </div>
            <div>
              <label className="text-sm font-semibold">Last name</label>
              <input
                type="text"
                defaultValue="muller"
                className="w-full border rounded px-3 py-2 mt-1 text-sm focus:outline-none focus:ring"
              />
            </div>
            <div>
              <label className="text-sm font-semibold">Phone number</label>
              <input
                type="tel"
                placeholder="Phone number"
                className="w-full border rounded px-3 py-2 mt-1 text-sm focus:outline-none focus:ring"
              />
            </div>
            <div>
              <label className="text-sm font-semibold">Postal code or City, State</label>
              <input
                type="text"
                defaultValue="Toronto, ON Canada"
                className="w-full border rounded px-3 py-2 mt-1 text-sm focus:outline-none focus:ring"
              />
              <div className="text-xs text-gray-500 mt-1">Optional</div>
            </div>
            <button
              type="submit"
              className="w-full bg-black hover:bg-black text-white font-semibold py-2 rounded text-sm"
            >
              Continue
            </button>
          </form>
        </div>
      </div>

      {showReview && (
        <ReviewApplicationModal job={job} onClose={() => setShowReview(false)} />
      )}
    </>
  );
};

export default QuickApplyModal;
